import React, {
  useRef,
} from "react";
import styled, {css} from 'styled-components';
import { MetaProvider } from "./context";
import { ToastProvider } from 'react-toast-notifications';


import { Store } from "./components/Store";
// import './shopify.css';

function App() {
  const body = useRef();

  return (
    <div className="App bdy" ref={body}>
       <ToastProvider>
      <CSSutility><img height='8' src='https://api.netlify.com/api/v1/badges/907d79cf-2fcf-483e-8b3a-c6673ac439c8/deploy-status'/></CSSutility>
      <MetaProvider>


        <Store/>

      </MetaProvider>
      </ToastProvider>
    </div>
  );
}

const CSSutility = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000000;
  display: flex;
  justify-content: flex-end;
`

export default App;
